// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue';
import App from './App';

import router from './router';
import ElementUI from 'element-ui';
import '../node_modules/element-ui/lib/theme-chalk/index.css';	//�ֶ����
import Public_components from '@/components/index';
import axios from 'axios';
import { copyFile } from 'fs';
import store from "./store";
import './styles/common.scss'
import * as filters from './filters' // global filters
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css';
import './icons'
import baseMixin from '@/components/Mixin/base';
import './directive';
import './utils/collectUtil'
import preventClick from './utils/clickStatefrom'  // 防止重复点击按钮

import vueSwiper from 'vue-awesome-swiper'  //引入vue-awesome-swiper
import 'swiper/dist/css/swiper.css'  //引入样式
import 'animate.css'


import {getLanguage} from "@/utils/auth";
import VueI18n from 'vue-i18n'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import locale from 'element-ui/lib/locale';
import zh from './language/zh-CH.json';
import en from './language/en-US.json';
import inputTrim from './utils/inputTrim'// 引入输入框去除空格
Vue.use(VueI18n,);
Vue.use(inputTrim)
export const i18n = new VueI18n({
  locale:getLanguage(), // 这里是开始的默认语言，我这里默认是中文
  messages: {
    "zh-CN": {...zh,...zhLocale}, // 这里是在找语言所在的文件位置
    "en-US": {...en,...enLocale},
  },
});
locale.i18n((key, value) => i18n.t(key, value)) //为了实现element插件的多语言切换
let I18n=getLanguage()
if(!I18n){
  I18n="zh-CN";
}
window.document.documentElement.setAttribute('data-language', I18n);




Vue.directive('removeAriaHidden', {
  bind(el, binding) {
    const ariaEls = el.querySelectorAll('.el-radio__original')
    ariaEls.forEach((item) => {
      item.removeAttribute('aria-hidden')
    })
  }
})

Vue.use(vueSwiper)  //使用插件

import IdleVue from "idle-vue";

const eventsHub = new Vue();
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 10*60*1000,
  startAtIdle: false
});
// 修改 el-dialog 默认点击遮罩为不关闭
ElementUI.Dialog.props.closeOnClickModal.default = false;
// MessageBox弹窗默认点击遮罩为不关闭 prompt,confirm
window.elPrompt=ElementUI.MessageBox.prompt;
ElementUI.MessageBox.prompt= function (){
  let options={};
  // debugger
  if(arguments.length==2){
    options=arguments[1];
  }else if(arguments.length==3){
    options=arguments[2];
  }
  if(! options.closeOnClickModal){
    options.closeOnClickModal=false;
  }
  return window.elPrompt(...arguments)
}

window.elConfirm=ElementUI.MessageBox.confirm;
ElementUI.MessageBox.confirm= function (){
  let options={};
  // debugger
  if(arguments.length==2){
    options=arguments[1];
  }else if(arguments.length==3){
    options=arguments[2];
  }
  if(! options.closeOnClickModal){
    options.closeOnClickModal=false;
  }
  return window.elConfirm(...arguments)
}


// axios.defaults.baseURL = "http://127.0.0.1:20060/pack" //gyh
// axios.defaults.baseURL = "http://192.168.0.163:20060/pack" //zc
// axios.defaults.baseURL = 'http://192.168.0.162:20060/pack' //lzx
//axios.defaults.baseURL = 'http://192.168.0.244:20060/pack' //zxs

axios.defaults.baseURL = 'https://pack.fnjkj.cn/pack' //生产环境
// axios.defaults.baseURL = 'https://gray-pack.fnjkj.cn/pack' //灰度环境
//axios.defaults.baseURL = 'http://fnjkjtest3.pack.fnjkj.cn:20060/pack'  //测试环境

 // axios.defaults.baseURL = 'https://dev.fnjkj.cn/pack' //生产环境



Vue.config.productionTip = false
/* eslint-disable no-new */
Vue.use(ElementUI)
Vue.use(Public_components);
Vue.use(Viewer);
Vue.mixin(baseMixin);
Vue.use(preventClick)


Vue.prototype.$message = function(msg){
  // ElementUI.Message(msg)
  ElementUI.Message({...msg,showClose:true,offset:200,})
}
const messageArr = ['success', 'warning', 'info', 'error']
messageArr.forEach(function (type) {
  let configDet = {
      showClose: true,
      offset:200
  }
  Vue.prototype.$message[type] = function (message) {
      return ElementUI.Message[type]({
          message,
          ...configDet
      });
  }
})
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
});
Viewer.setDefaults({
  Options: {
    "inline": true, "button": true, "navbar": true, "title": true, "toolbar": true,
    "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true,
    "transition": true, "fullscreen": false, "keyboard": true, "url": "data-source"
  }
});
axios.interceptors.request.use(function (config) {
  let token = sessionStorage.getItem("token")
  config.headers['access-token'] = token
  let language = localStorage.getItem("I18n")=="en-US"?"en":"cn"
  config.headers['language'] = language
  return config;
}, function (error) {
  return Promise.reject(error);
});
Vue.prototype.$axios = axios;
Vue.prototype.$EventBus = new Vue();
let theme=localStorage.getItem("theme")
if(!theme){
  theme="theme2";
}
window.document.documentElement.setAttribute('data-theme', theme);
store.dispatch('settings/changeSetting', {
  key: 'theme',
  value: theme
})
new Vue({
  i18n, //把 i18n 挂载到 vue 根实例上components
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})





// WEBPACK FOOTER //
// ./src/main.js